/**
 * Where the working-context bar is pointed: a company, a depot.
 *
 * Same reasoning as the catalogue's `scope.ts`: the scope is the
 * application's, shown once in its header, and this package declares only
 * the shape it needs plus a hook to read it. The application injects the
 * real one through `referentialRoutes` (`useScope`); without it, screens
 * fall back to "every company, no depot" — a working screen, not a broken
 * one.
 */

export interface ReferentialScope {
  /** Empty means every company. */
  companyCode: string;
  /** Empty means no depot pre-selected. */
  siteCode: string;
  /** Which articles to list: active ones, inactive ones, or all. Absent means all. */
  active?: "all" | "active" | "inactive";
}

export const EMPTY_SCOPE: ReferentialScope = { companyCode: "", siteCode: "" };

export function useLocalScope(): ReferentialScope {
  return EMPTY_SCOPE;
}
